import React from 'react';
import Image from "next/image";
import myLoader from "../utils/myLoader";
import {useRouter} from "next/router";

function NewsCard({news, locale}) {
    const router = useRouter();
    return (
        <div className="news-card">
            <div className="img-container">
                <Image
                    onClick={() =>
                        router.push(`/news/${news?._id}`)
                    }
                    src={news.img} loader={myLoader} alt={"news-img"} objectFit={"cover"} layout={"fill"}/>
            </div>
             <h1>{locale === "ka" ? news.ka.title : news.eng.title}</h1>
        </div>
    );
}

export default NewsCard;
